import { Modal } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ActivatedWarranty from "../../components/warranty/activatedWarranty";
import WarrantyConfirm from "../../components/warranty/confirm";
import InformationCustomer from "../../components/warranty/infoCustomer";
import InformationWarranty from "../../components/warranty/infoWarranty";
import OtpModal from "../../components/warranty/otpModal";
import RegisterWarranty from "../../components/warranty/registerWarranty";
import ResultRegisterWarranty from "../../components/warranty/resultRegister";
import {
  getInfoWarranty,
  selectInfoWarranty,
} from "../../redux/reducers/slice/warranty";
import { warrantyServices } from "../../services";
import "./style.scss";

const Warranty = (props: any) => {
  const [step, setStep] = useState(1);
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const infoWarranty = useSelector(selectInfoWarranty);

  const handleConfirmOTP = (otp: string) => {
    warrantyServices.validateOTPActiveWarrantyInfo(
      otp,
      infoWarranty?.uid,
      async (data, error) => {
        console.log("handleConfirmOTP: ", data, error);
        // setVisible(true);

        if (data) {
          setVisible(false);
          await dispatch(getInfoWarranty(infoWarranty?.uid || ""));

          setStep(5);
        }

        if (error) {
          console.log(error);

          Modal.error({
            title: "Lỗi",
            content: "Mã OTP không đúng.",
            okText: "Đóng",
          });
        }
      }
    );
  };

  return (
    <>
      <section id="warranty">
        <div className="warranty">
          {step === 0 && <ActivatedWarranty setStep={setStep} {...props} />}
          {step === 1 && (
            <InformationWarranty
              setStep={setStep}
              setVisible={setVisible}
              {...props}
            />
          )}
          {step === 2 && <RegisterWarranty setStep={setStep} {...props} />}
          {step === 3 && <InformationCustomer setStep={setStep} {...props} />}
          {step === 4 && (
            <WarrantyConfirm
              setStep={setStep}
              setVisible={setVisible}
              {...props}
            />
          )}
          {step === 5 && (
            <ResultRegisterWarranty setStep={setStep} {...props} />
          )}
        </div>
      </section>

      <OtpModal
        visible={visible}
        setVisible={setVisible}
        handleConfirmOTP={handleConfirmOTP}
        phoneNumber={infoWarranty?.customer_phone_no}
      />
    </>
  );
};

export default Warranty;
